/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import SearchPlotC from 'components/SearchPlot';
import { useMainContext } from 'pages/PublicPage/Layout';
import ModalWarningClearVerify from 'pages/PublicPage/ModalWarningClearVerify';

export default function SearchPlot({ onSelect }) {
  const {
    setPlotSelected,
    claimchainRef,
    selectPolygon,
    certVerify,
    setCert,
    setCertVerify,
  } = useMainContext();
  const [plotsWaitingClick, setPlotsWaitingClick] = useState(null);

  const navigatePlot = (plot) => {
    onSelect(plot);
    let fetchClaimChain = true;
    // if plot is in claimchain, don't need fetch claimchain
    if (claimchainRef.current?.plots) {
      fetchClaimChain = !Boolean(
        claimchainRef.current.plots.find((i) => i._id === plot._id),
      );
    }
    setPlotSelected(plot, fetchClaimChain);
    selectPolygon({ polygon: plot.geojson });
    if (certVerify?.plot?.id !== plot?._id) {
      setCertVerify({
        index: -1,
        list: [],
        plot: null,
      });
      setCert(null);
    }
  };

  const onSelectPlot = (plot) => {
    if (certVerify?.list?.length > 0 && certVerify?.plot?.id !== plot?._id) {
      setPlotsWaitingClick(plot);
    } else {
      navigatePlot(plot);
    }
  };

  return (
    <>
      <ModalWarningClearVerify
        open={Boolean(plotsWaitingClick)}
        onClick={() => navigatePlot(plotsWaitingClick)}
        onClose={() => setPlotsWaitingClick(null)}
      />
      <SearchPlotC onSelect={onSelectPlot} />
    </>
  );
}
